// extracted by mini-css-extract-plugin
export default {"root":"style_root__QxiEP","icon":"style_icon__QfHPs","label":"style_label__pGPl4"};